"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * throw result of `toError`
 *
 * @example
 * ```ts
 * const result: never = pipe(
 *   0,
 *
 *   throwError((input) => Error(`input is ${input}`)),
 *
 *   (input: never) => {
 *     // unreachable point
 *   },
 * );
 * ```
 */
var throwError = function (toError) {
    return function (input) {
        throw toError(input);
    };
};
exports.default = throwError;
//# sourceMappingURL=throwError.js.map